export const checkTaxForRectificationCode = (
  code: string,
  codeExtra?: string | number
): boolean => {
  const { code265, code1072 } = mainCheckTaxForRectificationCode(
    code,
    codeExtra
  );

  return code265 || code1072;
};

export const mainCheckTaxForRectificationCode = (
  code: string,
  codeExtra?: string | number
) => {
  const normalizedExtra = codeExtra?.toString().trim();

  const code265List = ['265', '1219'];
  const code1072List = ['5015', '5016', '10-72', '10-78', '72', '78'];

  const code265 =
    code265List.includes(code) || code265List.includes(normalizedExtra || '');
  const code1072 =
    code1072List.includes(code) || code1072List.includes(normalizedExtra || '');

  return {
    code265,
    code1072,
  };
};
